function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBE9FD"
    },
    d: "M456.348,512H55.652C24.968,512,0,487.032,0,456.348V55.652C0,24.968,24.968,0,55.652,0h400.696 C487.032,0,512,24.968,512,55.652v400.696C512,487.032,487.032,512,456.348,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5DCFD"
    },
    d: "M456.348,0H256v512h200.348C487.032,512,512,487.032,512,456.348V55.652 C512,24.968,487.032,0,456.348,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6243"
    },
    d: "M432.974,102.4L299.409,202.574c-5.009,3.784-11.798,4.452-17.475,1.558L256,191.221l-31.61-15.805 L99.061,269.357c-3.005,2.226-6.567,3.339-10.017,3.339c-5.12,0-10.129-2.337-13.357-6.678c-5.565-7.346-4.007-17.809,3.339-23.374 L212.591,142.47c5.009-3.784,11.798-4.452,17.475-1.558L256,153.823l31.61,15.805l125.329-93.941 c7.346-5.565,17.809-4.007,23.374,3.339S440.32,96.835,432.974,102.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60AED5"
    },
    d: "M439.652,512V189.217c0-9.217-7.479-16.696-16.696-16.696c-9.217,0-16.696,7.479-16.696,16.696V512 H439.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60AED5"
    },
    d: "M372.87,512V239.304c0-9.217-7.479-16.696-16.696-16.696c-9.217,0-16.696,7.479-16.696,16.696V512 H372.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60AED5"
    },
    d: "M306.087,512V289.391c0-9.217-7.479-16.696-16.696-16.696c-9.217,0-16.696,7.479-16.696,16.696V512 H306.087z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6BBAE2"
    },
    d: "M239.304,512V256c0-9.217-7.479-16.696-16.696-16.696s-16.696,7.479-16.696,16.696v256H239.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6BBAE2"
    },
    d: "M172.522,512V306.087c0-9.217-7.479-16.696-16.696-16.696s-16.696,7.479-16.696,16.696V512H172.522z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6BBAE2"
    },
    d: "M105.739,512V356.174c0-9.217-7.479-16.696-16.696-16.696s-16.696,7.479-16.696,16.696V512H105.739z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF3501"
    },
    d: "M432.974,102.4L299.409,202.574c-5.009,3.784-11.798,4.452-17.475,1.558L256,191.221v-37.398 l31.61,15.805l125.329-93.941c7.346-5.565,17.809-4.007,23.374,3.339S440.32,96.835,432.974,102.4z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/line-chart.cf4b820e36abcca3e0532392f15ff928.svg";
export { ForwardRef as ReactComponent };